angular.module('clients')
    .component('clientList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/clients/list.html',
        controller: function ($scope, $state, $stateParams, ClientService, ClientConst) {
            this.reset = () => this.filters = {}
            this.ClientService = ClientService
            $scope.$on(ClientConst.eventUpdate, () => $state.reload())
        }
    })
